const LOCAL_STORAGE_VISITOR_TOKEN_KEY = "truth:visitor-token";
const VISITOR_TOKEN_HEADER = "X-Visitor-Token";

function isPepeEndpoint(url: string | undefined): boolean {
  if (!url) return false;

  return url.includes("/pepe/");
}

function getCachedVisitorToken(): string | undefined {
  if (typeof window === "undefined") return undefined;

  const token = localStorage.getItem(LOCAL_STORAGE_VISITOR_TOKEN_KEY);
  return token || undefined;
}

function cacheVisitorToken(token: string): void {
  if (typeof window === "undefined") return;

  localStorage.setItem(LOCAL_STORAGE_VISITOR_TOKEN_KEY, token);
}

function getVisitorTokenRequestHeaders(): Record<string, string> {
  const token = getCachedVisitorToken();

  if (!token) return {};

  return { [VISITOR_TOKEN_HEADER]: token };
}

function persistVisitorTokenFromHeaders(
  headers: Record<string, unknown> | undefined,
): void {
  const token = headers?.["x-visitor-token"];

  if (typeof token === "string" && token.length > 0) {
    cacheVisitorToken(token);
  }
}

function omitVisitorTokenHeader(headers: unknown): void {
  if (!headers || typeof headers !== "object") return;

  const record = headers as Record<string, unknown> & {
    delete?: (name: string) => void;
  };

  if (typeof record.delete === "function") {
    record.delete(VISITOR_TOKEN_HEADER);
    record.delete(VISITOR_TOKEN_HEADER.toLowerCase());
    return;
  }

  delete record[VISITOR_TOKEN_HEADER];
  delete record[VISITOR_TOKEN_HEADER.toLowerCase()];
}

export {
  LOCAL_STORAGE_VISITOR_TOKEN_KEY,
  VISITOR_TOKEN_HEADER,
  cacheVisitorToken,
  getCachedVisitorToken,
  getVisitorTokenRequestHeaders,
  isPepeEndpoint,
  omitVisitorTokenHeader,
  persistVisitorTokenFromHeaders,
};
